import { gql } from "@apollo/client";

export const CUSTOM_TREE_CHECKOUT = gql`
    mutation customTreeCheckout(
        $input: CustomTreeCheckoutInput!
    ) {
    customTreeCheckout(input: $input) {
        sessionURL
    }
}`;